import LegalPageLayout from "@/pages/LegalPageLayout";

export default function Privacy() {
  return (
    <LegalPageLayout title="Privacy Policy: Home, Twice App">
      <p>
        This page explains how the Home, Twice App at app.kwadernoco.com (&quot;the App&quot;) handles your information. The App is run by Kwaderno &amp; Co., Toronto, Ontario, Canada. Our online store has its own policy at{" "}
        <a href="https://x4hw5p-sy.myshopify.com/policies/privacy-policy" target="_blank" rel="noopener noreferrer">
          https://x4hw5p-sy.myshopify.com/policies/privacy-policy
        </a>. Questions? Email <a href="mailto:hello@kwadernoco.com">hello@kwadernoco.com</a>.
      </p>

      <section className="legal-section">
        <h2>What we collect</h2>
        <ul>
          <li>Your email address, to sign you in with a 6-digit code. There are no passwords.</li>
          <li>Your voice recordings, and which page of the book each one belongs to.</li>
          <li>Basic technical information, such as your device, browser, and IP address, which our hosting and sign-in providers may log to keep the App working and secure.</li>
          <li>A small amount of data saved in your browser so you stay signed in. We don&apos;t use advertising or analytics cookies or trackers.</li>
        </ul>
        <p>Recording is optional. You can use the book without the App.</p>
      </section>

      <section className="legal-section">
        <h2>How we use it</h2>
        <p>
          We use your information to sign you in, save and play back your recordings, let you share a recording if you choose, keep the App secure, and answer your support questions. We do not sell your information or use it for advertising. We do not use your recordings to train AI or voice models, and we don&apos;t send them to any transcription or analysis service. We don&apos;t listen to your recordings unless you ask us to for support, or we need to investigate abuse or respond to a legal request.
        </p>
      </section>

      <section className="legal-section">
        <h2>Who can hear your recordings</h2>
        <p>
          Only you, while you&apos;re signed in. If you choose to share a recording, we make a link for it. Anyone who has the link can listen without signing in, and they can pass the link on. The listening page doesn&apos;t show your name or email, but the voice itself may identify you. You can turn a link off at any time. Once it&apos;s off, it stops working for new listeners. A link someone has already opened may keep playing for up to 5 minutes. If you create a new link for a recording, the old link stops working. Anyone who already saved a copy of the audio keeps it.
        </p>
      </section>

      <section className="legal-section">
        <h2>Who handles information for us, and where</h2>
        <ul>
          <li>Supabase stores our database, sign-in information, and recordings, on servers in Canada.</li>
          <li>Netlify hosts the App.</li>
          <li>Resend sends your sign-in codes.</li>
        </ul>
        <p>These providers handle information to help us run the service, and some may handle it outside Canada.</p>
      </section>

      <section className="legal-section">
        <h2>How long we keep it, and how to delete it</h2>
        <p>We keep your recordings until you delete them.</p>
        <ul>
          <li>Delete a recording: open it and choose &quot;Delete this recording.&quot; The audio is removed, and its share link is turned off.</li>
          <li>Replace a recording: when you record a new version of a page, the previous version is deleted once the new one has saved.</li>
          <li>Delete your account: use &quot;Delete my account&quot; in the App. This deletes all your recordings, share links, and account information.</li>
          <li>You can also email <a href="mailto:hello@kwadernoco.com">hello@kwadernoco.com</a> and we&apos;ll do it for you, within 30 days.</li>
          <li>To get a copy of your recordings, email us from the address you signed in with.</li>
        </ul>
        <p>Copies may remain in our providers&apos; backups for a short time after deletion. We may keep something longer if the law requires it.</p>
      </section>

      <section className="legal-section">
        <h2>Other people&apos;s voices</h2>
        <p>Recordings may include family members or friends. Only record people who have agreed to it. Don&apos;t record children without a parent or guardian&apos;s permission. The App is for adults and isn&apos;t meant for children, and we don&apos;t knowingly collect information from children.</p>
      </section>

      <section className="legal-section">
        <h2>Please don&apos;t record</h2>
        <p>ID numbers, passwords, or financial details.</p>
      </section>

      <section className="legal-section">
        <h2>Your rights</h2>
        <p>Depending on where you live, you can ask us to show you what information we have about you, correct it, give you a copy, delete your account and recordings, or turn off a share link. Email <a href="mailto:hello@kwadernoco.com">hello@kwadernoco.com</a>. If you have a complaint, you can also contact the Office of the Privacy Commissioner of Canada or your local data protection authority.</p>
      </section>

      <section className="legal-section">
        <h2>Security</h2>
        <p>We use reasonable safeguards, but no system is completely secure.</p>
      </section>

      <section className="legal-section">
        <h2>Changes</h2>
        <p>If we change this policy, we&apos;ll update the date at the top.</p>
      </section>

      <p>Contact: <a href="mailto:hello@kwadernoco.com">hello@kwadernoco.com</a></p>
    </LegalPageLayout>
  );
}
